import { useMutation, useQueryClient } from '@tanstack/react-query';
import { DIAM_API_PATH, resendInvitation } from '../../diamApi';
import { useApiEssentials } from '../../../../shared/hooks/useApiEssentials';

export function useResendInvitation() {
  const { getIdToken, apiUrl } = useApiEssentials(DIAM_API_PATH);
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (invitationId: string) => {
      const idToken = await getIdToken();
      return resendInvitation(apiUrl, idToken, invitationId);
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['diam', 'invitations'] });
    },
  });
}
